// eslint-disable-next-line import/no-unresolved
import KeenSlider from './keen-slider-with-wheel.js'

if (!customElements.get('collection-carousel')) {
  customElements.define(
    'collection-carousel',
    class CollectionFeature extends window.BAO.CustomElement {
      constructor() {
        super()

        // if (this.els.slide.elements.length < 3) return

        // this.slideDirection = this.els.slides.element.dataset.directionright == 'true' ? true : false

        this.carousel = this.initialiseCarousel()

      }

      initialiseCarousel(e) {

        console.log('initialiseCarousel', this.els)

        this.els.slides.element.setAttribute(
          'data-custom-cursor-external-el',
          'carousel',
        )


        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          mode: 'snap',
          slidesPerView: 1.3,
          slides: '.car-Carousel_Slide',
          spacing: 1,
          loop: true,
          centered: false,
          navgation: "true",
          // rtl: this.slideDirection,
          breakpoints: {
            '(min-width: 768px)': {
              loop: true,
              mode: 'snap',
              navgation: 'true',
              slidesPerView: 3,
              spacing: 1,
            },
          },
          move: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide,
              )
            })
          },
          created: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.addEventListener('click', () => {
                instance.moveToSlide(dot.dataset.slide)
              })
            })
            this.els.prev.elements.forEach(prev => {
              prev.addEventListener('click', () => {
                instance.moveToSlide(instance.details().relativeSlide - 1)
              })
            })
            this.els.next.elements.forEach(next => {
              next.addEventListener('click', () => {
                instance.moveToSlide(instance.details().relativeSlide + 1)
              })
            })
          },
          slideChanged: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.setAttribute(
                'aria-current',
                parseInt(dot.dataset.slide) === instance.details().relativeSlide,
              )
            })
          },
        })
      }
    },
  )
}
